module.exports = __webpack_public_path__ + "img/1f_r_inamatsu.cbd3f070.jpg";